'use client';

export function SchemaMarkDown({
  schemaString,
}: {
  schemaString?: string | undefined;
}) {
  if (!schemaString) {
    return null;
  }
  const theObj = { __html: schemaString };
  return <div dangerouslySetInnerHTML={theObj} />;
}

export default SchemaMarkDown;
